export default __webpack_public_path__ + "images/icon-map-blue.a55c3b1e.svg";